export default __webpack_public_path__ + "static/media/heading.b1d548e8.png";